import type { CSSProperties } from 'react';
import { cn } from '@/lib/cn';

type SkeletonProps = { className?: string; width?: CSSProperties['width']; height?: CSSProperties['height'] };

/**
 * A placeholder block. Size it to the real content it replaces so nothing
 * moves when data lands. Decorative: the surrounding region sets aria-busy.
 */
export function Skeleton({ className, width, height }: SkeletonProps) {
  return <span aria-hidden="true" style={{ width, height }} className={cn('block animate-pulse rounded-[4px] bg-wash', className)} />;
}
